const TransactionType = {
  Sale: "sale",
  Refund: "refund",
  Void: "void",
  NonSale: "non-sale",
  ManualAdjustment: "manual-adjustment",
  Return: "return",
};

export default TransactionType;
